import { render, staticRenderFns } from "./CACG1060.vue?vue&type=template&id=0423ac64"
import script from "./CACG1060Controller.ts?vue&type=script&lang=ts&external"
export * from "./CACG1060Controller.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports